
import { useEffect, useState } from "react";

import { useDispatch, } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import { ProfileSubmenuDropDown } from "../../Redux/Slice/PostSlice";
import { confirmAlert } from 'react-confirm-alert'

export default function InvitationActionCard({ contact, reloadList }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [deleteWhatsappModalOpenClose, setdeleteWhatsappModalOpenClose] = useState(false);
    const [index, setIndex] = useState(null)


    const hideOnOutsideClick = (event) => {
        if (!event.target.closest('.iommdot')) {
            setdeleteWhatsappModalOpenClose(false);
            setIndex(null);
        }
    };

    useEffect(() => {
        if (deleteWhatsappModalOpenClose) {
            document.addEventListener('mousedown', hideOnOutsideClick);
        } else {
            document.removeEventListener('mousedown', hideOnOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', hideOnOutsideClick);
        };
    }, [deleteWhatsappModalOpenClose]);

    const removeInvitation = async (e, id) => {
        e.preventDefault()

        const res = await HttpClient.requestData(
            `notification-delete/${id}`,
            "DELETE"
        );
        if (res && res?.status) {
            // setShowPopup(!showPopup);
            reloadList()
            toast.success("Request removed successfully");
        } else {
            toast.error("Error occured");
        }
    }

    const openPopover = (clickedIndex) => {
        // Only show the popup for the clicked contact
        setIndex(clickedIndex);
        setdeleteWhatsappModalOpenClose(true);
    };

    const confirmMessage = (e, msgText, id) => {
        e.preventDefault()
        confirmAlert({
            title: (
                <h4>Confirm delete</h4>
            ),
            message: (
                <p>
                    {msgText}
                </p>
            ),
            buttons: [
                {
                    label: "Yes",
                    onClick: () => removeInvitation(e, id),
                    className: 'btn btn-primary',
                },
                {
                    label: "No",
                    className: 'btn btn-secondary',
                },
            ],
        });
    }

    return (
        <div className="buttonwrap_asse">

            <div
                onClick={(e) => {
                    e.stopPropagation();
                    openPopover(contact?._id);
                    dispatch(ProfileSubmenuDropDown(false));
                }}
                className="iommdot"
            >
                <i className="fa-solid fa-ellipsis"></i>

                {index === contact?._id && deleteWhatsappModalOpenClose && (
                    <div className="dropDelete">
                        <ul>
                            <li>
                                <NavLink title="View Profile" to={`/profile/${contact?.connectionSendorData?.userName}`}><i className="fa fa-eye view" aria-hidden="true" /> </NavLink>
                            </li>
                            <li>
                                <i
                                    className="fa-solid fa-trash-can trash"
                                    onClick={(e) => confirmMessage(e, "Are you sure you want to remove this invitation?", contact?._id)}
                                    title="Remove Invitation"
                                ></i>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}

